import { Component, Input, OnInit, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { LottieComponent, AnimationOptions } from 'ngx-lottie';
import { HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-lottie-animation',
  template: `
    <ng-lottie 
       *ngIf="options"
       [options]="options" 
       [width]="width" 
       [height]="height"
       (animationCreated)="animationCreated($event)">
    </ng-lottie>
  `,
  standalone: true,
  imports: [LottieComponent, CommonModule],
  styles: []
})
export class LottieAnimationComponent implements OnInit, OnDestroy, OnChanges {
  @Input() animationPath: string = 'assets/animation/animation-optimized.json';
  @Input() width: string = '150px';
  @Input() height: string = '150px';
  @Input() loop: boolean = true;
  @Input() autoplay: boolean = true;

  options: AnimationOptions | null = null;
  private animationItem: any = null;

  constructor(private http: HttpClient) {}

  ngOnInit() {
    this.loadAnimation();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['animationPath'] && !changes['animationPath'].firstChange) {
      this.loadAnimation();
    }
  }

  private loadAnimation() {
    // Load animation data as JSON object so embedded base64 images work correctly
    this.http.get(this.animationPath).subscribe({
      next: (animationData: any) => {
        this.options = {
          animationData: animationData,
          loop: this.loop,
          autoplay: this.autoplay,
          rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
          }
        };
      },
      error: (err) => {
        console.error('Failed to load Lottie animation:', err);
        // Fallback to path-based loading
        this.options = {
          path: this.animationPath,
          loop: this.loop,
          autoplay: this.autoplay
        };
      }
    });
  }

  animationCreated(animationItem: any): void {
    this.animationItem = animationItem;
  }

  play() { this.animationItem?.play(); }
  pause() { this.animationItem?.pause(); }
  stop() { this.animationItem?.stop(); }
  setSpeed(speed: number) { this.animationItem?.setSpeed(speed); }
  
  ngOnDestroy() {
    if (this.animationItem) {
      this.animationItem.destroy();
    }
  }
}
